module.exports = __webpack_public_path__ + "static/media/the-shadows.1105c2c1.PNG";